import React, { useEffect, useState } from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import axios from "../helper/axios";

export default function Privacy() {

  const [allCms, setAllCms] = useState([]);
  const apiData = async () => {
    const res = await axios.post("/getcms");
    console.log(res?.status);
    if (res.status === 200) {
      setAllCms(res?.data);
    } else {
      setAllCms()
    }
  }

  useEffect(() => {
    apiData();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0 });
  };
  useEffect(() => {
    scrollToTop();
  }, [])

  return (
    <>
      <Header />
      <div className='container mx-auto pt-24'>
        <div className="Cart mt-heading">
          <div className="p-0-mobile container wishlist">
            <div className="">
              <div className="CartItem fade-in-down">
                <div className="CartItem__content delivery">
                  {allCms?.length > 0 && allCms?.map((dt, index) => (
                    dt.slugTitle === "privacy" ? (
                      <>
                        <h2 className='privacy-heading'><strong>{dt.pageTitle}</strong></h2>
                        <div
                          dangerouslySetInnerHTML={{ __html: dt.pageContent }}
                        />
                      </>
                    ) : null

                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
